import React, { createContext, useContext } from 'react'
import { HoldingInterface } from '../Typescript/UI_Interfaces'
//import { useLocalStorage } from '@uidotdev/usehooks' //FIXME: https://github.com/uidotdev/usehooks/issues/264
import { useLocalStorage } from 'usehooks-ts'

interface HoldingContextType {
  currentHolding: HoldingInterface
  setHolding: any
}

export const HoldingContext = createContext<HoldingContextType>(
  {} as HoldingContextType,
)
export const useHoldingContext = () => useContext(HoldingContext)

function CurrentHolding({ children }: { children: any }) {
  const [currentHolding, setHolding] = useLocalStorage('holding', {
    value: 31,
    name: 'ABR - ABRShipping',
  } as HoldingInterface)

  return (
    <HoldingContext.Provider
      value={{
        currentHolding,
        setHolding,
      }}
    >
      {children}
    </HoldingContext.Provider>
  )
}

export default CurrentHolding
